<template>
  <div>
    <es-loader v-if="loading" style="margin: 25rem" size="5x"/>
    <es-exception v-else-if="loadingError" exceptionMessage="search not found."/>
    <div v-else>
      <div>
        <es-profile-header>
          <template #profile-header>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="header-title">
                    Search Profile
                  </div>
                  <div class="header-subtitle">
                    Contains one or many records.
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #profile-overview>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ search.id }}
                  </div>
                  <div class="column-subtitle">
                    Search ID
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    <div>
                      {{ search.submissionTypeCode }}
                    </div>
                    <div
                      v-if="search.submissionTypeCode === 'FILE'"
                      class="max-width" style="margin: auto"
                    >
                      ({{ search.fileName }})
                    </div>
                  </div>
                  <div class="column-subtitle">
                    Submission Type
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ formatDateTime(search.createdDate) }}
                  </div>
                  <div class="column-subtitle">
                    Process Info
                  </div>
                </div>
              </div>
              <div class="column is-narrow">
                <div class="column-content">
                  <div>
                    <pid-status-info-icon
                      :header="true"
                      :processStatus="search.status"
                    />
                  </div>
                  <div class="column-subtitle">
                    Status
                  </div>
                </div>
              </div>
            </div>
          </template>
        </es-profile-header>
        <div class="tabs-container">
          <div class="tabs no-bottom-border">
            <ul>
              <router-link
                :to="{ name: 'PidSearchInfoDetails' }"
                tag="li"
                replace
              >
                <a>DETAILS</a>
              </router-link>
              <router-link v-if="hasModule('PRSID:DWNLD:DOWNLOAD')"
                :to="{ name: 'PidSearchInfoDownload' }"
                tag="li"
                replace
              >
                <a aria-label="Download Search" role="link" tabindex="0">
                  DOWNLOAD
                </a>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
      <router-view :search="search" @refreshTheBatch="loadSearch"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import PidStatusInfoIcon from '@/components/PidStatusInfoIcon.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsLoader,
    EsProfileHeader,
    PidStatusInfoIcon,
  },
  props: [
    'searchId',
  ],
  data() {
    return {
      search: {},
      loading: false,
      loadingError: false,
    };
  },
  created() {
    this.loadPersonTypes();
    this.loadSearch();
  },
  mounted() {
    this.setBreadcrumbs();
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mm A');
    },
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'personId' } },
        { text: 'Processing Information ', to: {} },
      ]);
    },
    async loadSearch() {
      try {
        this.loading = true;
        this.loadingError = false;
        const res = await axios.get(`person-search/by-file/${this.searchId}`);
        this.search = res.data;
      } catch (error) {
        this.apiMsg = `${error.response.status === 500
          ? 'Network Error'
          : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  .header-title
    color: #000 !important
    font-weight: 700 !important
  .header-subtitle
    color: #6c757d
  .margin-bottom
    margin-bottom: 1rem
  .max-width
    max-width: 20ch
  .progress-bar
    height: 5px
    width: 75px
    margin-bottom: 3px
    margin-left: 1rem
</style>
